import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, throwError, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

// INTERFACES
import { IClientCreditMemo } from '../../../../client/interfaces';

// SERVICES
import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ClientCreditMemoApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _creditMemos = new BehaviorSubject<IClientCreditMemo[]>(
    <IClientCreditMemo[]>[],
  );

  loading$ = this._loading.asObservable();
  creditMemos$ = this._creditMemos.asObservable();

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get(data :{
    businessAccountId :number;
    params ?:{
      [param :string] :string | string[];
    };
  }) :Subscription {
    const { businessAccountId, params = {} } = data;
    this._loading.next(true);

    return this.apiService
      .get(
        `${this.environment.urlV2}/b2b-portal/${businessAccountId}/credit-memos`,
        {
          params,
        },
      )
      .subscribe({
        next: ({ data } :any) => {
          this._creditMemos.next(data);
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  create(
    businessAccountId :number,
    params :IClientCreditMemo,
  ) :Observable<IClientCreditMemo> {
    this._loading.next(true);

    return this.apiService
      .post({
        path: `${this.environment.urlV2}/b2b-portal/${businessAccountId}/credit-memos`,
        body: params,
      })
      .pipe(
        tap({
          next: (response :IClientCreditMemo) => {
            this._loading.next(false);
          },
          error: (error) => {
            this._loading.next(false);
          },
        }),
      );
  }

  update(
    businessAccountId :number,
    creditMemoId :number,
    payload :IClientCreditMemo,
  ) :Observable<IClientCreditMemo> {
    this._loading.next(true);

    return this.apiService
      .put(
        `${this.environment.urlV2}/b2b-portal/${businessAccountId}/credit-memos/${creditMemoId}`,
        payload,
      )
      .pipe(
        tap({
          next: (response :IClientCreditMemo) => {
            this._loading.next(false);
          },
          error: (error) => {
            this._loading.next(false);
          },
        }),
      );
  }
}
